/**
 * Normalize a list endpoint's payload to an array.
 *
 * A non-array body — an `{error: ...}` object, an HTML error page, an undefined body
 * from a failed interceptor retry — must never reach state. Every list page spreads,
 * sorts and maps these during render, so a bad payload does not fail the fetch, it
 * throws inside a `useMemo` and unmounts the whole app.
 *
 * The warning is the point of the helper: a swallowed payload leaves nothing to debug
 * with. Mirrors the inline guard in BreedingPage.js.
 */
export const toArray = (payload, label) => {
  if (Array.isArray(payload)) {
    return payload;
  }
  if (payload !== undefined && payload !== null) {
    console.warn(`${label || 'API'} returned a non-array payload; using empty list`, payload);
  }
  return [];
};

export default toArray;
